import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import styles from './indicator.module.scss'

const Indicator = (props) => {
  const { active, size, percent } = props

  const indicatorClasses = classNames(styles.indicator, {
    [styles.active]: active,
    [styles[size]]: size
  })

  return <div style={{ height: `${percent}px` }} className={indicatorClasses} />
}

Indicator.defaultProps = {
  active: false,
  size: null,
  percent: 30
}

Indicator.propTypes = {
  active: PropTypes.bool,
  size: PropTypes.string,
  percent: PropTypes.number
}

export default Indicator
